import React from "react";
import { getImageOnlyChoiceSlots } from "./stage5ImageOnlyUtils";
import "./quizImageCard.css";

const CARD_THEMES = [
  { accent: "#7b3fa8" },
  { accent: "#d94f8c" },
  { accent: "#e8892a" },
  { accent: "#4aa8d8" },
  { accent: "#3db89a" },
];

export default function QuizImageCard({
  question,
  index,
  selectedKey,
  disabled,
  onSelect,
}) {
  const theme = CARD_THEMES[index % CARD_THEMES.length];
  const choices = getImageOnlyChoiceSlots(question);

  return (
    <article
      className="quiz-image-card"
      style={{ "--qic-accent": theme.accent }}
    >
      <div className="quiz-image-card__media">
        {question.image ? (
          <img
            className="quiz-image-card__image"
            src={question.image}
            alt={`Question ${index + 1}`}
          />
        ) : (
          <p className="quiz-image-card__empty">No image</p>
        )}
      </div>

      <div
        className="quiz-image-card__options"
        role="radiogroup"
        aria-label={`Question ${index + 1}`}
      >
        {choices.map((choice) => {
          const id = `image-only-q${index}-${choice.key}`;
          const checked = selectedKey === choice.key;
          return (
            <label
              key={choice.key}
              htmlFor={id}
              className={`quiz-image-card__option${
                checked ? " quiz-image-card__option--selected" : ""
              }`}
            >
              <input
                id={id}
                type="radio"
                name={`image-only-q-${index}`}
                value={choice.key}
                checked={checked}
                disabled={disabled}
                onChange={() => onSelect(choice.key)}
              />
              <span className="quiz-image-card__radio" aria-hidden />
              <span className="quiz-image-card__label">{choice.label}</span>
            </label>
          );
        })}
      </div>
    </article>
  );
}
